/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Types of permission scopes */
export enum ScopeType {
  Global,
  Organization,
  Department,
  Project,
  Resource,
  Individual,
}

export type ScopeTypeArgs = ScopeType;

export function getScopeTypeEncoder(): FixedSizeEncoder<ScopeTypeArgs> {
  return getEnumEncoder(ScopeType);
}

export function getScopeTypeDecoder(): FixedSizeDecoder<ScopeType> {
  return getEnumDecoder(ScopeType);
}

export function getScopeTypeCodec(): FixedSizeCodec<ScopeTypeArgs, ScopeType> {
  return combineCodec(getScopeTypeEncoder(), getScopeTypeDecoder());
}
